import { Storage } from "aws-amplify";
import moment from "moment";

export const acceptedFileTypes = ["image/*"].join(",");

export const uploadImageToS3 = async (file, setUploadStatus, uploadStatus) => {
    return await Storage.put("public/" + file.uniqueName, file, {
        progressCallback(progress) {
            setUploadStatus(
                new Map(
                    uploadStatus.set(file.uniqueName, {
                        ...(!uploadStatus.has(file.uniqueName)
                            ? { uploadStartTime: moment().utc(true) }
                            : null),
                        ...uploadStatus.get(file.uniqueName),
                        apiTriggered: false,
                        isLoading: false,
                        isError: false,
                        totalUploaded: progress.loaded,
                        progress: Math.floor((progress.loaded / progress.total) * 100),
                    })
                )
            );
        },
    });
};

export const addThousandSeparator = (str: string | number) => {
    const parts = String(str)?.split(".");
    parts[0] = parts[0]?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

    return parts?.join(".");
};
